import React from "react";
import { useTranslation } from "react-i18next";
import { heroImages, photos } from "../data/mock";
import { useTestimonials } from "../i18n/content";
import { PageHero, Reveal, Eyebrow, SectionTitle, StarRow, CTASection } from "../components/common";
import { Gauge, ShieldCheck, Users, Fish, Heart, Award } from "lucide-react";

const ICONS = [Gauge, ShieldCheck, Users, Fish, Heart, Award];

const About = () => {
  const { t } = useTranslation();
  const testimonials = useTestimonials();
  const values = t("aboutPage.values", { returnObjects: true }) || [];
  return (
    <>
      <PageHero image={heroImages[4].img} eyebrow={t("aboutPage.heroEyebrow")} title={t("aboutPage.heroTitle")} sub={t("aboutPage.heroSub")} />
      <section className="py-16">
        <div className="container-x grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <Eyebrow>{t("aboutPage.storyEyebrow")}</Eyebrow>
            <h2 className="font-display text-4xl text-white leading-tight">{t("aboutPage.storyTitle")}</h2>
            <p className="text-slate-300 mt-4">{t("aboutPage.p1")}</p>
            <p className="text-slate-300 mt-3">{t("aboutPage.p2")}</p>
          </Reveal>
          <Reveal delay={0.15} className="grid grid-cols-2 gap-4">
            <img src={photos.captain} alt="Hog Tide captain" className="rounded-2xl h-72 w-full object-cover" />
            <img src={heroImages[2].img} alt="Sunset" className="rounded-2xl h-72 w-full object-cover mt-8" />
          </Reveal>
        </div>
      </section>
      <section className="py-8 bg-[#071726]">
        <div className="container-x grid gap-8 md:grid-cols-3">
          {(Array.isArray(values) ? values : []).map((v, i) => {
            const Icon = ICONS[i] || Fish;
            return (
              <div key={i} className="rounded-2xl bg-[#0e2740] border border-white/10 p-6"><Icon className="h-8 w-8 text-[#f5a524]" /><h3 className="font-heading text-xl text-white mt-3">{v.t}</h3><p className="text-sm text-slate-400 mt-1">{v.d}</p></div>
            );
          })}
        </div>
      </section>
      <section className="py-16">
        <div className="container-x">
          <SectionTitle center eyebrow={t("aboutPage.testimonialsEyebrow")} title={t("aboutPage.testimonialsTitle")} />
          <div className="grid gap-6 md:grid-cols-2">
            {testimonials.map((r, i) => (
              <Reveal key={r.name} delay={i * 0.08}><div className="rounded-2xl bg-[#0e2740] border border-white/10 p-6"><StarRow n={r.rating} /><p className="text-slate-300 text-sm mt-3">"{r.text}"</p><p className="font-heading text-white mt-4">{r.name}</p></div></Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTASection image={heroImages[0].img} />
    </>
  );
};

export default About;
